import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { PropTypes } from 'prop-types';

import { Modal, Row, Col, Typography, Skeleton, List } from 'antd';
import { Card } from 'react-bootstrap';
import moment from 'moment';

import PutAwayDetailBoardActions from '../../Stores/PutAwayDetailBoard/Actions';

const { Text } = Typography;

class CompletePutAwayDialog extends React.PureComponent {
  constructor() {
    super();

    this.handleCancel = this.handleCancel.bind(this);
    this.convertExpiryDate = this.convertExpiryDate.bind(this);
    this.renderItem = this.renderItem.bind(this);
  }

  handleCancel() {
    const { setDialogVisible } = this.props;

    setDialogVisible(false);
  }

  convertExpiryDate(expiryDate) {
    // eslint-disable-next-line no-unused-vars
    const { intl } = this.props;

    let diffDays = 0;
    if (expiryDate !== null) {
      const thisDate = new Date();
      const oneDay = 24 * 60 * 60 * 1000;
      diffDays = Math.round(Math.abs((expiryDate.getTime() - thisDate.getTime()) / oneDay));
    }

    let backgroundColor = 'white';
    if (diffDays <= 90) {
      backgroundColor = 'red';
    } else if (diffDays <= 180) {
      backgroundColor = 'orange';
    } else if (diffDays <= 270) {
      backgroundColor = 'yellow';
    }
    return backgroundColor;
  }

  renderItem(record) {
    const { intl } = this.props;

    return (
      <Card className="rowcard" key={record.id}>
        <Card.Header>
          {`${record.shipping_doc_code} ${record.doc_code}`}
          {` ${intl.formatMessage({ id: 'est_del_date' })}: ${moment(record.est_del_date).format(
            'YYYY-MM-DD'
          )}`}
        </Card.Header>
        <Card.Body>
          <Card.Title className="infotext" style={{ fontSize: '15px', wordBreak: 'break-all' }}>
            {`${record.biz_partner_code} ${record.biz_partner_company_name_01}`}
          </Card.Title>
          <Card.Text className="infotext">
            {record.biz_partner_unit_no}
            {record.biz_partner_building_name && (
              <>
                <br />
                {record.biz_partner_building_name}
              </>
            )}
            {record.biz_partner_street_name && (
              <>
                <br />
                {record.biz_partner_street_name}
              </>
            )}
            {record.biz_partner_district_01 && (
              <>
                <br />
                {record.biz_partner_district_01}
              </>
            )}
            {record.biz_partner_district_02 && (
              <>
                <br />
                {record.biz_partner_district_02}
              </>
            )}
            {record.biz_partner_postcode && (
              <>
                <br />
                {record.biz_partner_postcode}
              </>
            )}
            {record.biz_partner_state_name && (
              <>
                <br />
                {record.biz_partner_state_name}
              </>
            )}
            {record.biz_partner_country_name && (
              <>
                <br />
                {record.biz_partner_country_name}
              </>
            )}
          </Card.Text>
        </Card.Body>
      </Card>
    );
  }

  render() {
    const { intl, dialogIsVisible, document, documentIsLoading } = this.props;

    return (
      <>
        <Modal
          visible={dialogIsVisible}
          title={
            // eslint-disable-next-line react/jsx-wrap-multilines
            <Text>
              {document.doc_code}
              {document.ref_code_01 !== document.doc_code && <>{` ${document.ref_code_01}`}</>}
            </Text>
          }
          // style={{top:20}}
          width="50%"
          centered
          // onOk={this.handleOk}
          onCancel={this.handleCancel}
          footer={null}
          className="pick-list-dialog"
        >
          {documentIsLoading === true ? (
            <Skeleton active />
          ) : (
            <Row type="flex">
              <Col span={20} style={{ margin: 'auto' }}>
                <DialogRow
                  header={<Text>{intl.formatMessage({ id: 'created_at' })}</Text>}
                  details={<Text>{document.created_at}</Text>}
                />
                <DialogRow
                  header={<Text>{intl.formatMessage({ id: 'doc_date' })}</Text>}
                  details={<Text>{moment(document.doc_date).format('YYYY-MM-DD')}</Text>}
                />
                <DialogRow
                  header={<Text>{intl.formatMessage({ id: 'from_storage_bin' })}</Text>}
                  details={<Text>{document.storage_bin_code}</Text>}
                />
                <DialogRow
                  header={<Text>{intl.formatMessage({ id: 'pallet_qty' })}</Text>}
                  details={
                    // eslint-disable-next-line react/jsx-wrap-multilines
                    <Text>
                      {new Intl.NumberFormat([], {
                        style: 'decimal',
                        minimumFractionDigits: 5,
                        maximumFractionDigits: 5
                      }).format(document.pallet_qty)}
                    </Text>
                  }
                />
                <DialogRow
                  header={<Text>{intl.formatMessage({ id: 'case_qty' })}</Text>}
                  details={
                    // eslint-disable-next-line react/jsx-wrap-multilines
                    <Text>
                      {new Intl.NumberFormat([], {
                        style: 'decimal',
                        minimumFractionDigits: 5,
                        maximumFractionDigits: 5
                      }).format(document.case_decimal_qty)}
                    </Text>
                  }
                />
                <DialogRow
                  header={<Text>{intl.formatMessage({ id: 'gross_weight' })}</Text>}
                  details={
                    // eslint-disable-next-line react/jsx-wrap-multilines
                    <Text>
                      {new Intl.NumberFormat([], {
                        style: 'decimal',
                        minimumFractionDigits: 5,
                        maximumFractionDigits: 5
                      }).format(document.gross_weight)}
                    </Text>
                  }
                />
                <DialogRow
                  header={<Text>{intl.formatMessage({ id: 'cubic_meter' })}</Text>}
                  details={
                    // eslint-disable-next-line react/jsx-wrap-multilines
                    <Text>
                      {new Intl.NumberFormat([], {
                        style: 'decimal',
                        minimumFractionDigits: 5,
                        maximumFractionDigits: 5
                      }).format(document.cubic_meter)}
                    </Text>
                  }
                />
                <Row type="flex" gutter={[8, 8]} className="modalinfo-row">
                  <Col span={24} className="modalinfo-details">
                    <List
                      itemLayout="horizontal"
                      dataSource={document.inb_ord_hdrs}
                      renderItem={this.renderItem}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
        </Modal>
      </>
    );
  }
}

function DialogRow(props) {
  // eslint-disable-next-line react/prop-types
  const { className, header, details } = props;
  return (
    <Row type="flex" gutter={[8, 8]} className={className || 'modalinfo-row'}>
      <Col span={5} className="modalinfo">
        {header}
      </Col>
      <Col span={19} className="modalinfo-details">
        {details}
      </Col>
    </Row>
  );
}

CompletePutAwayDialog.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  setDialogVisible: PropTypes.func,
  dialogIsVisible: PropTypes.bool,
  document: PropTypes.shape({
    doc_code: PropTypes.string,
    ref_code_01: PropTypes.string,
    doc_status: PropTypes.number,
    created_at: PropTypes.string,
    doc_date: PropTypes.string,
    storage_bin_code: PropTypes.string,
    pallet_qty: PropTypes.string,
    case_decimal_qty: PropTypes.string,
    gross_weight: PropTypes.string,
    cubic_meter: PropTypes.string,
    inb_ord_hdrs: PropTypes.arrayOf(PropTypes.object)
  }),
  documentIsLoading: PropTypes.bool
};

CompletePutAwayDialog.defaultProps = {
  intl: {},
  setDialogVisible() {},
  dialogIsVisible: false,
  document: {
    doc_code: '',
    doc_status: 3,
    created_at: '',
    doc_date: null,
    storage_bin_code: '',
    pallet_qty: '',
    case_decimal_qty: '',
    gross_weight: '',
    cubic_meter: '',
    inb_ord_hdrs: []
  },
  documentIsLoading: false
};

const mapStateToProps = state => ({
  timestamp: state.putAwayDetailBoard.completePutAwayDialogTimestamp,
  dialogIsVisible: state.putAwayDetailBoard.completePutAwayDialogIsVisible,
  docId: state.putAwayDetailBoard.completePutAwayDocId,
  document: state.putAwayDetailBoard.completePutAwayDocument,
  documentIsLoading: state.putAwayDetailBoard.completePutAwayDocumentIsLoading
});

const mapDispatchToProps = dispatch => ({
  setDialogVisible: boolean =>
    dispatch(PutAwayDetailBoardActions.putAwayDetailBoardSetCompletePutAwayDialogVisible(boolean))
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CompletePutAwayDialog));
